var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMikeMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.424 17.3601L15.2087 14.1449C16.2421 12.8208 16.8035 11.1895 16.804 9.50996H14.906C14.9053 10.6861 14.5374 11.8328 13.8536 12.7897L12.4756 11.4118C12.8059 10.8509 13.008 10.2065 13.008 9.50996V3.81594C13.008 1.712 11.314 0 9.23191 0C9.16548 0 9.09905 0.00854112 9.03356 0.0237252C8.0591 0.0707387 7.14002 0.490672 6.46661 1.19659C5.7932 1.9025 5.41702 2.84034 5.41596 3.81594V4.35213L1.34189 0.278058L0 1.61995L17.0821 18.702L18.424 17.3601ZM3.51796 9.50996H1.61995C1.61995 13.3743 4.5239 16.5668 8.26297 17.0365V19H10.161V17.0356C10.8869 16.9448 11.5959 16.7495 12.2659 16.4557L10.7873 14.9772C10.2755 15.1264 9.74514 15.2028 9.21198 15.204C6.07172 15.204 3.51796 12.6493 3.51796 9.50996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42969 9.61719C5.4574 10.5842 5.85393 11.5041 6.53801 12.1881C7.2221 12.8722 8.14193 13.2688 9.10897 13.2965L5.42969 9.61719Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikeMute);
export default __webpack_public_path__ + "static/media/mike_mute.6dcb8370.svg";
export { ForwardRef as ReactComponent };